// Single source of truth for destination islands shown in the main nav.
// Display name matches what the backend stores in hotels/tours.island field
// so query-param filtering works directly (?island=Rodos).
export const DESTINATIONS_NAV = [
  { slug: "sakiz",     name: "Sakız" },
  { slug: "samos",     name: "Samos" },
  { slug: "midilli",   name: "Midilli" },
  { slug: "rodos",     name: "Rodos" },
  { slug: "kos",       name: "Kos" },
  { slug: "santorini", name: "Santorini" },
  { slug: "mykonos",   name: "Mykonos" },
];
